import { Component } from '@angular/core';

/** Coquille hôte : barre de titre + liste fournisseurs bibliothèque. */
@Component({
  selector: 'app-fournisseurs-list-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class FournisseursListShellComponent {}
